if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.isCartPage = document.querySelector('body.template-cart');
      this.form = this.querySelector('form');
      this.form?.querySelector('[name=id]') && (this.form.querySelector('[name=id]').disabled = false);
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.pdCartModal = document.querySelector('.pd-cart-notification .modal__toggle');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.submitButton?.addEventListener('click', this.onSubmitHandler.bind(this));

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.productCard = this.closest('[data-product-card]');
      this.selectVariant = this.productCard?.querySelector('[name="selectVariant"]');
      if (this.selectVariant) {
        this.selectVariant?.addEventListener('change', () => {
          this.querySelector('[name="id"]').value = this.selectVariant.value;
        })
      }
    }

    isGifboxProduct() {
      return this.dataset.isGiftboxProduct === 'true'
    }

    triggerRenderCartOrCartRelevant(productVariantId) {
      const sectionsRender = [
        {
          id: '.pd-header',
          selector: '.pd-header #cart-icon-bubble',
          section: '.pd-header #cart-icon-bubble',
          sectionId: document.querySelector('.pd-header')?.getAttribute('data-section-id')
        },
        {
          id: 'main-cart-items-wrapper',
          selector: '#main-cart-items-wrapper',
          section: '#main-cart-items-wrapper',
          sectionId: document.getElementById('main-cart-items-wrapper')?.getAttribute('data-id')
        },
      ]

      const ELM_cartNotification = document.querySelector('.pd-cart-notification');

      const currentHandle = this.getAttribute('data-product-handle');
      const currentVariantId = this.querySelector('[name="id"]').value;
      if (this.closest('pd-cart-modal')) {
        ELM_cartNotification?.open(_, productVariantId, currentHandle, true);
      } else {
        ELM_cartNotification?.open(_, productVariantId, currentHandle);
      }

      Promise.all([
        fetch(window.Shopify.routes.root + `?sections=${sectionsRender.map(section => section.sectionId).join(',')}`).then(res => res.json()).catch(() => { }),
        fetch(window.Shopify.routes.root + `cart?view=items-modal`).then(res => res.text()).catch(() => { }),
        fetch(window.Shopify.routes.root + `products/${currentHandle}`).then(res => res.text()).catch(() => { })
      ])
        .then(res => {
          const [res0, res1, res2] = res;

          sectionsRender.forEach((section) => {
            const json = res0[section.sectionId];
            const html = new DOMParser().parseFromString(json, 'text/html');
            if (document.querySelector(section.selector)) {
              document.querySelector(section.selector).innerHTML = html.querySelector(section.section)?.innerHTML
            }
          })

          const html1 = new DOMParser().parseFromString(res1, 'text/html');
          const cartNotificationContent = html1.getElementById('cart-notification-product');
          const cartNotificationContentModified = cartNotificationContent.querySelectorAll(`[data-productvariantid="${currentVariantId}"]`);

          cartNotificationContent.querySelector('.cart-items tbody').innerHTML = '';
          cartNotificationContentModified.forEach((item) => cartNotificationContent.querySelector('.cart-items tbody').appendChild(item));

          if (document.getElementById("cart-notification-product")) {
            document.getElementById("cart-notification-product").innerHTML = cartNotificationContent.innerHTML
          }

          if (document.getElementById("CartNotificationCheckout")) {
            const html2 = new DOMParser().parseFromString(res2, 'text/html');
            document.getElementById("CartNotificationCheckout").innerHTML =
              html2.getElementById("CartNotificationCheckout").innerHTML;
          }

        }).catch((e) => {
          console.log(e);
        })
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const isGiftboxProduct = this.isGifboxProduct();

      if (document.body.getAttribute('registry-cart') && !isGiftboxProduct) {
        const ELM_registryCartWarning = document.querySelector('registry-cart-warning');
        return ELM_registryCartWarning.open();
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList?.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      console.log('formData', formData)

      const ELM_cartNotification = document.querySelector('.pd-cart-notification');
      ELM_cartNotification?.show();
      if (!this.closest('pd-cart-modal')) {
        ELM_cartNotification?.toggleLoading(true);
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            ELM_cartNotification?.close();
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            const productVariantId = formData.get('id');
            this.triggerRenderCartOrCartRelevant(productVariantId);
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList?.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
